import { useTheme } from 'next-themes';
import greeninCompanyColor from '@/assets/greenin-company-color.svg';
import greeninCompanyBlack from '@/assets/greenin-company-black.svg';
import greeninImpactColor from '@/assets/greenin-impact-color.svg';
import greeninImpactBlack from '@/assets/greenin-impact-black.svg';
import greeninSymbol from '@/assets/greenin-ecosystem-symbol.svg';

interface ThemedGreeninLogoProps {
  variant: 'company' | 'impact' | 'symbol';
  className?: string;
  alt?: string;
}

const ThemedGreeninLogo = ({ variant, className = '', alt = 'GreenIn' }: ThemedGreeninLogoProps) => {
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === 'dark';

  const logos = {
    company: isDark ? greeninCompanyColor : greeninCompanyBlack,
    impact: isDark ? greeninImpactColor : greeninImpactBlack,
    symbol: greeninSymbol,
  };

  return <img src={logos[variant]} alt={alt} className={className} />;
};

export default ThemedGreeninLogo;
